import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-tab-spinner',
  templateUrl: './tab-spinner.component.html',
  styleUrls: ['./tab-spinner.component.scss'],
  host: {
    '[class.overlay-fixed]': 'fixed',
  },
})
export class TabSpinnerComponent {
  @Input() spinnerType = 'regular';
  @Input() fixed = false;
  /** Pin the spinner to the visible contract area instead of the full content height. */
  @Input() viewportCenter = false;
}
